const mixin = {
  methods: {
    /**
     * Set focus to the tab panel itself if there's no focusable element in the tab panel
     * @param event
     * @param componentEl HTML element of the tab component
     * @param panelEl HTML element of the tab panel
     */
    focusTabPanel: function (event, componentEl, panelEl) {
      // Focus on the tab panel if there's no focusable element inside it
      var tabpanel = panelEl ? panelEl : jQuery("[role=tabpanel]").focus();
      var panel = componentEl
        ? jQuery(tabpanel, componentEl)
        : jQuery(tabpanel);
      if (!event.shiftKey && jQuery(":tabbable", panel).length >= 0) {
        panel.addClass("tab-focus");
        panel.trigger("focus");
        event.preventDefault();
      }
    },
    /**
     * This function is to remove the focus as we don't want to set focus when someone clicks on the tab panels. And also results in flickering.
     * * @param event
     * @param componentEl HTML element of the tab component
     * @param panelEl HTML element of the tab panel
     */
    focusoutTabPanel: function (event, componentEl, panelEl) {
      var tabpanel = panelEl ? panelEl : jQuery("[role=tabpanel]").focus();
      var panel = componentEl
        ? jQuery(tabpanel, componentEl)
        : jQuery(tabpanel);
      if (panel.length > 0) {
        panel.removeClass("tab-focus");
      }
    }
  }
};

export default mixin;
